import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
export const LayoutTemplateSchema = z.enum(['full', 'split', 'side', 'ticker']);
/** Fixed templates from Ghost Screen Layouts.dc.html — not user-editable. */
export const LAYOUT_TEMPLATES = {
    full: {
        id: 'full',
        name: 'Full screen',
        description: 'One thing, edge to edge',
        cols: '1fr',
        rows: '1fr',
        zones: [{ key: 'Main', area: '1 / 1 / 2 / 2' }],
    },
    split: {
        id: 'split',
        name: 'Half and half',
        description: 'Two things side by side',
        cols: '1fr 1fr',
        rows: '1fr',
        zones: [
            { key: 'Left', area: '1 / 1 / 2 / 2' },
            { key: 'Right', area: '1 / 2 / 2 / 3' },
        ],
    },
    side: {
        id: 'side',
        name: 'Main + side panel',
        description: 'Big area plus a narrow strip',
        cols: '2.3fr 1fr',
        rows: '1fr',
        zones: [
            { key: 'Main', area: '1 / 1 / 2 / 2' },
            { key: 'Side', area: '1 / 2 / 2 / 3' },
        ],
    },
    ticker: {
        id: 'ticker',
        name: 'Main + scrolling text',
        description: 'Content with a news-style bar',
        cols: '1fr',
        rows: '1fr 20%',
        zones: [
            { key: 'Main', area: '1 / 1 / 2 / 2' },
            { key: 'Ticker', area: '2 / 1 / 3 / 2', ticker: true },
        ],
    },
};
export function layoutPlaylistZoneKeys(template) {
    return LAYOUT_TEMPLATES[template].zones.filter((zone) => !zone.ticker).map((zone) => zone.key);
}
export function layoutHasTicker(template) {
    return LAYOUT_TEMPLATES[template].zones.some((zone) => zone.ticker);
}
export const CreateLayoutRequestSchema = z.object({
    template: LayoutTemplateSchema,
    name: z.string().min(1).max(200).optional(),
});
export const UpdateLayoutRequestSchema = z
    .object({
    name: z.string().min(1).max(200).optional(),
    tickerText: z.string().max(2000).optional(),
    zones: z
        .record(z.string().min(1), z.string().min(1).nullable())
        .optional(),
})
    .refine((body) => body.name !== undefined || body.tickerText !== undefined || body.zones !== undefined, { message: 'At least one field is required' });
export const LayoutZoneSchema = z.object({
    key: z.string().min(1),
    playlistId: z.string().min(1).nullable(),
});
export const LayoutSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    name: z.string().min(1),
    template: LayoutTemplateSchema,
    tickerText: z.string(),
    zones: z.array(LayoutZoneSchema),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
//# sourceMappingURL=layout.js.map